module.exports = __webpack_public_path__ + "img/dsci0142.f2bfd79c.jpg";